/**
 * Cancer coverage skeleton
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getCancerSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.CANCER,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "cancer-plan-1",
      name: "Cancer Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.current,
      currentCarrierName: "",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "cancer",

        // Diagnosis Benefit
        diagnosisBenefitType: "notIncluded",
        diagnosisBenefitAmount: 1,

        // Initial Diagnosis Waiting Period
        initialDiagnosisWaitingPeriodType: undefined,
        initialDiagnosisWaitingPeriodDuration: 1,

        // Radiation Therapy / Chemo
        radiationTherapyChemoType: "notIncluded",
        radiationTherapyChemoAmount: 1,

        // Blood/Plasma/Platelets
        bloodPlasmaPlateletsType: "notIncluded",
        bloodPlasmaPlateletsAmount: 1,

        // Hospice
        hospiceType: undefined,
        hospiceAmount: 1,
        hospiceDuration: undefined,

        // Hospital Confinement - Initial
        hospitalConfinementInitialType: "notIncluded",
        hospitalConfinementInitialAmount: 1,

        // ICU Confinement - Initial
        icuConfinementInitialType: "notIncluded",
        icuConfinementInitialAmount: 1,

        // Skin Cancer
        skinCancerType: "notIncluded",
        skinCancerAmount: 1,

        // Surgical Benefit
        surgicalBenefitType: "notIncluded",
        surgicalBenefitAmount: 1,

        // Pre-Existing Condition
        preExistingConditionType: "none",
        preExistingConditionMonthsDetail: "01/01",

        // Portability
        portability: undefined,

        // Wellness Benefit
        wellnessBenefitType: "notIncluded",
        wellnessBenefitAmount: 1,

        // Waiver of Premium
        waiverOfPremium: undefined,

        // Annual Open Enrollment
        annualOpenEnrollment: "notIncluded",

        // Extended (non-v5) fields — CD-1665/CD-1983
        eligibilityHours: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
